import { Link } from 'react-router-dom';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-accent-950 border-t border-accent-900/50 mt-16 md:mt-24">
      <div className="w-full px-4 md:px-8 py-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
        <div className="sm:col-span-2 lg:col-span-1">
          <div className="flex items-center gap-2.5">
            <span className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center text-background-50">
              <i className="ri-play-fill text-xl"></i>
            </span>
            <span className="font-heading font-extrabold text-lg text-foreground-50">
              香蕉视频<span className="text-primary-400">app</span>
            </span>
          </div>
          <p className="mt-4 text-sm text-foreground-300/90 leading-relaxed max-w-xs">
            一站式高清影视信息平台，汇聚海量电影电视剧资源，多种播放模式，帮你更快找到想看的作品。
          </p>
          <div className="mt-5 flex items-center gap-3">
            {['ri-weibo-fill', 'ri-wechat-fill', 'ri-bilibili-fill', 'ri-mail-fill'].map((icon) => (
              <span
                key={icon}
                className="w-9 h-9 rounded-full bg-accent-900/60 flex items-center justify-center text-foreground-200 cursor-pointer hover:bg-primary-500 hover:text-background-50 transition-colors"
              >
                <i className={icon}></i>
              </span>
            ))}
          </div>
        </div>

        <div>
          <h4 className="font-heading font-semibold text-foreground-50 text-sm mb-4">内容导航</h4>
          <ul className="space-y-3 text-sm">
            <li><Link to="/" className="text-foreground-300/90 hover:text-primary-300 transition-colors cursor-pointer">首页</Link></li>
            <li><Link to="/category/movie" className="text-foreground-300/90 hover:text-primary-300 transition-colors cursor-pointer">电影频道</Link></li>
            <li><Link to="/category/tv" className="text-foreground-300/90 hover:text-primary-300 transition-colors cursor-pointer">电视剧频道</Link></li>
            <li><Link to="/search" className="text-foreground-300/90 hover:text-primary-300 transition-colors cursor-pointer">全文搜索</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-heading font-semibold text-foreground-50 text-sm mb-4">热门分类</h4>
          <ul className="space-y-3 text-sm">
            <li><Link to="/category/movie?genre=科幻" className="text-foreground-300/90 hover:text-primary-300 transition-colors cursor-pointer">科幻片</Link></li>
            <li><Link to="/category/movie?genre=悬疑" className="text-foreground-300/90 hover:text-primary-300 transition-colors cursor-pointer">悬疑片</Link></li>
            <li><Link to="/category/tv?genre=古装" className="text-foreground-300/90 hover:text-primary-300 transition-colors cursor-pointer">古装剧</Link></li>
            <li><Link to="/category/tv?region=日本" className="text-foreground-300/90 hover:text-primary-300 transition-colors cursor-pointer">日韩剧集</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-heading font-semibold text-foreground-50 text-sm mb-4">联系与说明</h4>
          <ul className="space-y-3 text-sm text-foreground-300/90">
            <li className="flex items-center gap-2">
              <i className="ri-mail-line text-primary-400"></i>
              support@bananavideo.example
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-time-line text-primary-400"></i>
              服务时间 09:00 - 22:00
            </li>
            <li>
              <Link to="/about" className="hover:text-primary-300 transition-colors cursor-pointer">关于我们 / 免责声明</Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-accent-900/50">
        <div className="w-full px-4 md:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-foreground-400">
          <p>© {year} 香蕉视频app · 本站为影视信息展示与观看指导平台</p>
          <p className="text-center">播放功能待接入 · 所有影视资料均为演示数据</p>
        </div>
      </div>
    </footer>
  );
}